import "./AccountWallet.css";
import { useEffect, useState } from "react";
import Icon from "../../../../components/base/Icon";
import { toastError, toastSuccess } from "../../../../components/base/Toast";
import SectionHeader, { SectionHeaderTab } from "../../../../components/layouts/section/SectionHeader";
import WalletUsageChart from "./WalletUsageChart";
import WalletDateFilter, { WalletDateRange } from "./WalletDateFilter";
import WalletStatsCards from "./WalletStatsCards";
import WalletTransactionsTable from "./WalletTransactionsTable";
import WalletChargeDrawer from "./WalletChargeDrawer";
import WalletSettings from "./WalletSettings";


const TABS: SectionHeaderTab[] = [
    { id: "overview", name: "Overview" },
    { id: "transactions", name: "Transactions" },
    { id: "settings", name: "Settings" },
]


export default function AccountWallet() {

    const [activeTab, activeTabSet] = useState<string>("overview")

    // Shared date range for the Overview widgets, driven by the per-tab date filter.
    const [dateRange, dateRangeSet] = useState<WalletDateRange>()

    const [chargeOpen, chargeOpenSet] = useState<boolean>(false)
    // Bumped after a successful top-up so the overview widgets refetch.
    const [refreshKey, refreshKeySet] = useState<number>(0)

    // After a 3-D Secure top-up, Stripe returns to the backend which redirects here with the outcome.
    // Toast success/failure (refreshing the widgets on success), then strip the query params.
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const payment = params.get("payment");
        if (!payment) return;

        if (payment === "success") {
            toastSuccess("Your wallet has been charged successfully!");
            refreshKeySet(k => k + 1);
        }
        else if (payment === "failed") toastError(params.get("message") || "Your wallet charge failed.");

        params.delete("payment");
        params.delete("message");
        const clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
        window.history.replaceState({}, "", clean);
    }, [])

    return (
        <div>
            <SectionHeader
                title="Wallet"
                icon="wallet"
                actions={
                    <button type="button" className="btn btn-sm btn-primary"
                        onClick={() => chargeOpenSet(true)}>
                        <Icon icon="wallet" type="solid" className="me-2" />
                        Add Balance
                    </button>
                }
                tabsActions={
                    activeTab === "overview" &&
                    <WalletDateFilter onChange={dateRangeSet} />
                }
                tabs={TABS}
                activeTab={activeTab}
                onTabChange={activeTabSet}
            />

            <div className="px-9 py-5">

                {
                    activeTab === "overview" &&
                    <>
                        <WalletStatsCards range={dateRange} refresh={refreshKey} />
                        <WalletUsageChart range={dateRange} />
                    </>
                }

                {
                    activeTab === "transactions" &&
                    <WalletTransactionsTable />
                }

                {
                    activeTab === "settings" &&
                    <WalletSettings />
                }

            </div>

            {
                chargeOpen &&
                <WalletChargeDrawer
                    onClose={() => chargeOpenSet(false)}
                    onSaved={() => refreshKeySet(k => k + 1)} />
            }
        </div>
    )
}
